import { Dispatch, SetStateAction, useState } from "react";
import { Button, Chip, Divider, Grid } from "@mui/material";
import Modal from "../../components/Modal/Modal";
import InputLabel from "../../components/Inputs/InputLabel";
import SelectSimple from "../../components/Selects/SelectSimple";
import InputCity from "../../components/Inputs/InputCity";
import SimpleBackdrop from "../../components/Loading/SimpleBackdrop";
import { AlertInfo } from "../../components/Alerts/Alert";
import { estadoCivilData, generoData, nacionalidadeData } from "../../data/dataCliente";
import { arrayUf } from "../../data/dataUf";
import { api } from "../../services/api";

type ModalDocumentoAvulsoProps = {
    open: boolean
    setOpen: Dispatch<SetStateAction<boolean>>
    index: number
}

export default function ModalDocumentoAvulso({ open, setOpen, index }: ModalDocumentoAvulsoProps) {
    const [load, setLoad] = useState(false);

    const [nome_1, setNome1] = useState("");
    const [rg_1, setRg1] = useState("");
    const [data_nascimento_1, setDataNascimento1] = useState("");
    const [cpf_1, setCpf1] = useState("");
    const [estado_civil_1, setEstadoCivil1] = useState<string | number>("");
    const [profissao_1, setProfissao1] = useState("");
    const [genero_1, setGenero1] = useState<string | number>("");
    const [nacionalidade_1, setNacionalidade1] = useState<string | number>("");
    const [uf_nascimento_1, setUfNascimento1] = useState<string | number>("PA");
    const [cidade_nascimento_1, setCidadeNascimento1] = useState("");

    const [endereco_1, setEndereco1] = useState("");
    const [numero_1, setNumero1] = useState("");
    const [cep_1, setCep1] = useState("");
    const [bairro_1, setBairro1] = useState("");
    const [uf_1, setUf1] = useState<string | number>("PA");
    const [cidade_1, setCidade1] = useState("");

    const [nome_2, setNome2] = useState("");
    const [rg_2, setRg2] = useState("");
    const [data_nascimento_2, setDataNascimento2] = useState("");
    const [cpf_2, setCpf2] = useState("");
    const [estado_civil_2, setEstadoCivil2] = useState<string | number>("");
    const [profissao_2, setProfissao2] = useState("");
    const [genero_2, setGenero2] = useState<string | number>("");
    const [nacionalidade_2, setNacionalidade2] = useState<string | number>("");
    const [uf_nascimento_2, setUfNascimento2] = useState<string | number>("PA");
    const [cidade_nascimento_2, setCidadeNascimento2] = useState("");

    const [endereco_2, setEndereco2] = useState("");
    const [numero_2, setNumero2] = useState("");
    const [cep_2, setCep2] = useState("");
    const [bairro_2, setBairro2] = useState("");
    const [uf_2, setUf2] = useState<string | number>("PA");
    const [cidade_2, setCidade2] = useState("");

    const [endereco, setEndereco] = useState("");
    const [numero, setNumero] = useState("");
    const [cep, setCep] = useState("");
    const [bairro, setBairro] = useState("");
    const [uf, setUf] = useState<string | number>("PA");
    const [cidade, setCidade] = useState("");
    const [data_inicio, setDataInicio] = useState("");

    const [data_inicio_atividade_rural, setDataInicioAtividadeRural] = useState("");
    const [uf_rural, setUfRural] = useState<string | number>("PA");
    const [cidade_rural, setCidadeRural] = useState("");
    const [nome_propriedade_rural, setNomePropriedadeRural] = useState("");
    const [tamanho_propriedade_rural, setTamanhoPropriedadeRural] = useState("");

    const [testemunha_1, setTestemunha1] = useState("");
    const [rg_testemunha_1, setRgTestemunha1] = useState("");
    const [cpf_testemunha_1, setCpfTestemunha1] = useState("");
    const [testemunha_2, setTestemunha2] = useState("");
    const [rg_testemunha_2, setRgTestemunha2] = useState("");
    const [cpf_testemunha_2, setCpfTestemunha2] = useState("");

    const [documentsType] = useState([
        {
            title: "DECLARAÇÃO DE UNIÃO ESTÁVEL",
            route: "/documentos/declaracao_uniao_estavel",
            divider1: 'Declarante 01',
            divider2: 'Declarante 02',
            data_final: 'Data Inicio Relação'
        },
        {
            title: "DECLARAÇÃO DE SEPARAÇÃO DE CORPOS",
            route: "/documentos/declaracao_separacao_corpos",
            divider1: 'Declarante',
            divider2: 'Declarado',
            data_final: 'Data Inicio Moradia'
        },
        {
            title: "DECLARAÇÃO DE RESIDÊNCIA",
            route: "/documentos/declaracao_residencia",
            divider1: 'Declarante',
            divider2: 'Declarado',
            data_final: 'Data Inicio Moradia'
        },
        {
            title: "CONTRATO DE PARCERIA RURAL",
            route: "/documentos/contrato_parceria_rural",
            divider1: 'Parceiro Outorgante',
            divider2: 'Parceiro Outorgado',
            data_final: ''
        },
        {
            title: "CONTRATO DE COMODATO RURAL",
            route: "/documentos/contrato_comodato_rural",
            divider1: 'Comodante',
            divider2: 'Comodatário',
            data_final: ''
        },
        {
            title: "DECLARAÇÃO DE CONFRONTANTES",
            route: "/documentos/declaracao_confrontante",
            divider1: 'Confrontado',
            divider2: 'Confortante 01, Confortante 02, e Confortante 03',
            data_final: ''
        },
    ]);

    async function handleDocument() {
        setLoad(true);
        try {
            const data = {
                nome_1: nome_1.toUpperCase(),
                rg_1,
                data_nascimento_1,
                cpf_1,
                estado_civil_1,
                profissao_1,
                genero_1,
                nacionalidade_1,
                uf_nascimento_1,
                cidade_nascimento_1,

                endereco_1,
                numero_1,
                cep_1,
                bairro_1,
                uf_1,
                cidade_1,

                nome_2: nome_2.toUpperCase(),
                rg_2,
                data_nascimento_2,
                cpf_2,
                estado_civil_2,
                profissao_2,
                genero_2,
                nacionalidade_2,
                uf_nascimento_2,
                cidade_nascimento_2,

                endereco_2,
                numero_2,
                cep_2,
                bairro_2,
                uf_2,
                cidade_2,

                endereco,
                numero,
                cep,
                bairro,
                uf,
                cidade,
                data_inicio,

                data_inicio_atividade_rural,
                uf_rural,
                cidade_rural,
                nome_propriedade_rural,
                tamanho_propriedade_rural,

                testemunha_1: testemunha_1.toUpperCase(),
                rg_testemunha_1,
                cpf_testemunha_1,
                testemunha_2: testemunha_2.toUpperCase(),
                rg_testemunha_2,
                cpf_testemunha_2,
            };

            api.post(documentsType[index].route, data, { responseType: 'blob' }).then(response => {
                if (response.status === 204) {
                    return AlertInfo({ icon: 'error', title: "Documento não localizado" });
                }
                const url = window.URL.createObjectURL(response.data);
                const link = document.createElement('a');
                link.href = url;
                link.download = `${documentsType[index].title} - ${nome_1.toUpperCase()}.docx`;
                link.click();
                window.URL.revokeObjectURL(url);
                setLoad(false);
            });
        } catch (error) {
            setLoad(false);
            console.log(error);
            AlertInfo({ icon: 'error', title: 'Falha na Conexão' });
        }
    }

    function closeModal() {
        setNome1("");
        setRg1("");
        setDataNascimento1("");
        setCpf1("");
        setEstadoCivil1("");
        setProfissao1("");
        setGenero1("");
        setNacionalidade1("");
        setUfNascimento1("PA");
        setCidadeNascimento1("");

        setEndereco1("");
        setNumero1("");
        setCep1("");
        setBairro1("");
        setUf1("PA");
        setCidade1("");

        setNome2("");
        setRg2("");
        setDataNascimento2("");
        setCpf2("");
        setEstadoCivil2("");
        setProfissao2("");
        setGenero2("");
        setNacionalidade2("");
        setUfNascimento2("PA");
        setCidadeNascimento2("");

        setEndereco2("");
        setNumero2("");
        setCep2("");
        setBairro2("");
        setUf2("PA");
        setCidade2("");

        setEndereco("");
        setNumero("");
        setCep("");
        setBairro("");
        setUf("PA");
        setCidade("");
        setDataInicio("");

        setDataInicioAtividadeRural("");
        setUfRural("PA");
        setCidadeRural("");
        setNomePropriedadeRural("");
        setTamanhoPropriedadeRural("");

        setTestemunha1("");
        setRgTestemunha1("");
        setCpfTestemunha1("");
        setTestemunha2("");
        setRgTestemunha2("");
        setCpfTestemunha2("");
    }

    return (
        <Modal
            open={open}
            setOpen={setOpen}
            title={documentsType[index].title}
            maxWidth="md"
            zIndex={2222}
            actionClose={closeModal}
        >
            <Grid container spacing={1}>
                <SimpleBackdrop open={load} />
                <Grid item xs={12}>
                    <Divider>
                        <Chip label={documentsType[index].divider1} size="small" color="primary" />
                    </Divider>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <InputLabel
                        label="Nome"
                        id="nome_1"
                        value={nome_1}
                        setState={setNome1}
                        next="rg_1"
                        autoFocus
                        isUpper
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <InputLabel
                        label="RG"
                        id="rg_1"
                        value={rg_1}
                        setState={setRg1}
                        next="data_nascimento_1"
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <InputLabel
                        label="Data Nascimento"
                        id="data_nascimento_1"
                        type="date"
                        value={data_nascimento_1}
                        setState={setDataNascimento1}
                        next="cpf_1"
                    />
                </Grid>

                <Grid item xs={12} sm={4}>
                    <InputLabel
                        label="CPF"
                        id="cpf_1"
                        value={cpf_1}
                        setState={setCpf1}
                        next="estado_civil_1"
                        mask="cpf"
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <SelectSimple
                        label="Estado Civil"
                        id="estado_civil_1"
                        value={estado_civil_1}
                        setState={setEstadoCivil1}
                        options={estadoCivilData}
                        next="profissao_1"
                        isNone
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <InputLabel
                        label="Profissão"
                        id="profissao_1"
                        value={profissao_1}
                        setState={setProfissao1}
                        next="genero_1"
                    />
                </Grid>

                <Grid item xs={12} sm={3}>
                    <SelectSimple
                        label="Genero"
                        id="genero_1"
                        value={genero_1}
                        setState={setGenero1}
                        options={generoData}
                        next="nacionalidade_1"
                        isNone
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <SelectSimple
                        id="nacionalidade_1"
                        label="Nacionalidade"
                        value={nacionalidade_1}
                        setState={setNacionalidade1}
                        options={nacionalidadeData}
                        isNone
                        next="uf_nascimento_1"
                    />
                </Grid>
                <Grid item xs={12} sm={2}>
                    <SelectSimple
                        label="UF Nascimento"
                        id="uf_nascimento_1"
                        value={uf_nascimento_1}
                        setState={setUfNascimento1}
                        options={arrayUf}
                        next="cidade_nascimento_1"
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <InputCity
                        label="Cidade Nascimento"
                        id="cidade_nascimento_1"
                        uf={uf_nascimento_1}
                        value={cidade_nascimento_1}
                        setValue={setCidadeNascimento1}
                        next={index === 3 ? "endereco_1" : "nome_2"}
                    />
                </Grid>

                {index === 3 && (
                    <>
                        <Grid item xs={12} sm={7}>
                            <InputLabel
                                label="Endereço"
                                id="endereco_1"
                                value={endereco_1}
                                setState={setEndereco1}
                                next="numero_1"
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <InputLabel
                                label="Numero"
                                id="numero_1"
                                value={numero_1}
                                setState={setNumero1}
                                next="cep_1"
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <InputLabel
                                label="CEP"
                                id="cep_1"
                                value={cep_1}
                                setState={setCep1}
                                next="bairro_1"
                                mask="cep"
                            />
                        </Grid>

                        <Grid item xs={12} sm={5}>
                            <InputLabel
                                label="Bairro"
                                id="bairro_1"
                                value={bairro_1}
                                setState={setBairro1}
                                next="uf_1"
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <SelectSimple
                                label="UF"
                                id="uf_1"
                                value={uf_1}
                                setState={setUf1}
                                options={arrayUf}
                                next="cidade_1"
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <InputCity
                                label="Cidade"
                                id="cidade_1"
                                uf={uf_1}
                                value={cidade_1}
                                setValue={setCidade1}
                                next="nome_2"
                            />
                        </Grid>
                    </>
                )}

                <Grid item xs={12}>
                    <Divider>
                        <Chip label={documentsType[index].divider2} size="small" color="primary" />
                    </Divider>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <InputLabel
                        label="Nome"
                        id="nome_2"
                        value={nome_2}
                        setState={setNome2}
                        next="rg_2"
                        autoFocus
                        isUpper
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <InputLabel
                        label="RG"
                        id="rg_2"
                        value={rg_2}
                        setState={setRg2}
                        next="data_nascimento_2"
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <InputLabel
                        label="Data Nascimento"
                        id="data_nascimento_2"
                        type="date"
                        value={data_nascimento_2}
                        setState={setDataNascimento2}
                        next="cpf_2"
                    />
                </Grid>

                <Grid item xs={12} sm={4}>
                    <InputLabel
                        label="CPF"
                        id="cpf_2"
                        value={cpf_2}
                        setState={setCpf2}
                        next="estado_civil_2"
                        mask="cpf"
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <SelectSimple
                        label="Estado Civil"
                        id="estado_civil_2"
                        value={estado_civil_2}
                        setState={setEstadoCivil2}
                        options={estadoCivilData}
                        next="profissao_2"
                        isNone
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <InputLabel
                        label="Profissão"
                        id="profissao_2"
                        value={profissao_2}
                        setState={setProfissao2}
                        next="genero_2"
                    />
                </Grid>

                <Grid item xs={12} sm={3}>
                    <SelectSimple
                        label="Genero"
                        id="genero_2"
                        value={genero_2}
                        setState={setGenero2}
                        options={generoData}
                        next="nacionalidade_2"
                        isNone
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <SelectSimple
                        id="nacionalidade_2"
                        label="Nacionalidade"
                        value={nacionalidade_2}
                        setState={setNacionalidade2}
                        options={nacionalidadeData}
                        isNone
                        next="uf_nascimento_2"
                    />
                </Grid>
                <Grid item xs={12} sm={2}>
                    <SelectSimple
                        label="UF Nascimento"
                        id="uf_nascimento_2"
                        value={uf_nascimento_2}
                        setState={setUfNascimento2}
                        options={arrayUf}
                        next="cidade_nascimento_2"
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <InputCity
                        label="Cidade Nascimento"
                        id="cidade_nascimento_2"
                        uf={uf_nascimento_2}
                        value={cidade_nascimento_2}
                        setValue={setCidadeNascimento2}
                        next={index === 3 ? "endereco_2" : "endereco"}
                    />
                </Grid>

                {index === 3 && (
                    <>
                        <Grid item xs={12} sm={7}>
                            <InputLabel
                                label="Endereço"
                                id="endereco_2"
                                value={endereco_2}
                                setState={setEndereco2}
                                next="numero_2"
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <InputLabel
                                label="Numero"
                                id="numero_2"
                                value={numero_2}
                                setState={setNumero2}
                                next="cep_2"
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <InputLabel
                                label="CEP"
                                id="cep_2"
                                value={cep_2}
                                setState={setCep2}
                                next="bairro_2"
                                mask="cep"
                            />
                        </Grid>

                        <Grid item xs={12} sm={5}>
                            <InputLabel
                                label="Bairro"
                                id="bairro_2"
                                value={bairro_2}
                                setState={setBairro2}
                                next="uf_2"
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <SelectSimple
                                label="UF"
                                id="uf_2"
                                value={uf_2}
                                setState={setUf2}
                                options={arrayUf}
                                next="cidade_2"
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <InputCity
                                label="Cidade"
                                id="cidade_2"
                                uf={uf_2}
                                value={cidade_2}
                                setValue={setCidade2}
                                next="endereco"
                            />
                        </Grid>
                    </>
                )}

                {index < 3 && (
                    <>
                        <Grid item xs={12}>
                            <Divider>
                                <Chip label="Endereço" size="small" color="primary" />
                            </Divider>
                        </Grid>

                        <Grid item xs={12} sm={7}>
                            <InputLabel
                                label="Endereço"
                                id="endereco"
                                value={endereco}
                                setState={setEndereco}
                                next="numero"
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <InputLabel
                                id="numero"
                                label="Numero"
                                value={numero}
                                setState={setNumero}
                                next="cep"
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <InputLabel
                                id="cep"
                                label="Cep"
                                value={cep}
                                setState={setCep}
                                mask="cep"
                                next="bairro"
                            />
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <InputLabel
                                id="bairro"
                                label="Bairro"
                                value={bairro}
                                setState={setBairro}
                                next="cidade"
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <SelectSimple
                                label="UF"
                                id="uf"
                                value={uf}
                                setState={setUf}
                                options={arrayUf}
                                next="cidade"
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <InputCity
                                label="Cidade"
                                id="cidade"
                                uf={uf}
                                value={cidade}
                                setValue={setCidade}
                                next="data_inicio"
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <InputLabel
                                id="data_inicio"
                                type="date"
                                label={documentsType[index].data_final}
                                value={data_inicio}
                                setState={setDataInicio}
                                next="testemunha_1"
                            />
                        </Grid>
                    </>
                )}

                {index === 3 && (
                    <>
                        <Grid item xs={12}>
                            <Divider>
                                <Chip label="Dados Rurais" size="small" color="primary" />
                            </Divider>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <InputLabel
                                id="data_inicio_atividade_rural"
                                type="date"
                                label="Data Inicio Atividade Rural"
                                value={data_inicio_atividade_rural}
                                setState={setDataInicioAtividadeRural}
                                next="cidade_rural"
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <SelectSimple
                                label="UF"
                                id="uf_rural"
                                value={uf_rural}
                                setState={setUfRural}
                                options={arrayUf}
                                next="cidade_rural"
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <InputCity
                                label="Cidade"
                                id="cidade_rural"
                                uf={uf_rural}
                                value={cidade_rural}
                                setValue={setCidadeRural}
                                next="nome_propriedade_rural"
                            />
                        </Grid>

                        <Grid item xs={12} sm={8}>
                            <InputLabel
                                id="nome_propriedade_rural"
                                label="Nome da Propriedade"
                                value={nome_propriedade_rural}
                                setState={setNomePropriedadeRural}
                                next="tamanho_propriedade_rural"
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <InputLabel
                                id="tamanho_propriedade_rural"
                                label="Tamanho da Propriedade"
                                value={tamanho_propriedade_rural}
                                setState={setTamanhoPropriedadeRural}
                                next="testemunha_1"
                            />
                        </Grid>
                    </>
                )}

                {[0, 3].includes(index) && (
                    <>
                        <Grid item xs={12}>
                            <Divider>
                                <Chip label="Testemunhas" size="small" color="primary" />
                            </Divider>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <InputLabel
                                label="Testemunha 01"
                                id="testemunha_1"
                                value={testemunha_1}
                                setState={setTestemunha1}
                                next="rg_testemunha_1"
                                isUpper
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <InputLabel
                                label="RG"
                                id="rg_testemunha_1"
                                value={rg_testemunha_1}
                                setState={setRgTestemunha1}
                                next="cpf_testemunha_1"
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <InputLabel
                                label="CPF"
                                id="cpf_testemunha_1"
                                value={cpf_testemunha_1}
                                setState={setCpfTestemunha1}
                                next="testemunha_2"
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <InputLabel
                                label="Testemunha 02"
                                id="testemunha_2"
                                value={testemunha_2}
                                setState={setTestemunha2}
                                next="rg_testemunha_2"
                                isUpper
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <InputLabel
                                label="RG"
                                id="rg_testemunha_2"
                                value={rg_testemunha_2}
                                setState={setRgTestemunha2}
                                next="cpf_testemunha_2"
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <InputLabel
                                label="CPF"
                                id="cpf_testemunha_2"
                                value={cpf_testemunha_2}
                                setState={setCpfTestemunha2}
                            />
                        </Grid>
                    </>
                )}

                <Grid item xs={false} sm={4}></Grid>
                <Grid item xs={12} sm={4}>
                    <Button
                        variant="contained"
                        fullWidth
                        color="success"
                        onClick={handleDocument}
                    >
                        GERAR DOCUMENTO
                    </Button>
                </Grid>
                <Grid item xs={false} sm={4}></Grid>
            </Grid>
        </Modal>
    );
}